import { CompositeFilterDescriptor } from "@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface";
import { State } from "@progress/kendo-data-query";
import * as React from "react";
import { concatFilter } from "./ConcatFilter";

export function applyFilter(
  filter: CompositeFilterDescriptor,
  currentDataState: State,
  setDataState: React.Dispatch<React.SetStateAction<State>>
) {
  setDataState({
    ...currentDataState,
    filter: concatFilter(filter, currentDataState),
  });
}

export const addFilterToCurrentDataState = (
  filter: CompositeFilterDescriptor,
  currentDataState: State
) => {
  return {
    ...currentDataState,
    filter: concatFilter(filter, currentDataState),
  };
};
